'use client';

var translations = {
    'I already have a CV': 'Tôi đã có hồ sơ ứng tuyển',
    'Create VietnamWorks Profile': 'Tạo Hồ Sơ VietnamWorks',
    'It takes about 5 - 8 minutes for a turn. Easily to apply CV whenever you want.': 'It takes about 5 - 8 minutes for a turn. Easily to apply CV whenever you want.',
    'It takes about 15 - 20 minutes for a turn. When you build a full profile, you get a lot jobs relevant from email.': 'It takes about 15 - 20 minutes for a turn. When you build a full profile, you get a lot jobs relevant from email.',
    'Job title': 'Chức danh',
    'First name': 'Tên',
    'Last name': 'Họ',
    'Current job level': 'Cấp bậc hiện tại',
    'Current job function': 'Ngành nghề hiện tại',
    'Current industry': 'Lĩnh vực hiện tại',
    'Current salary': 'Mức lương hiện tại',
    'Contact information': 'Thông tin cá nhân',
    'Basic information': 'Thông tin cơ bản',
    Email: 'Email',
    'Date of birth': 'Ngày sinh',
    'Phone number': 'Số điện thoại',
    Nationality: 'Quốc tịch',
    'Marital status': 'Tình trạng hôn nhân',
    Male: 'Nam',
    Female: 'Nữ',
    Single: 'Độc thân',
    Married: 'Đã kết hôn',
    Gender: 'Giới tính',
    Country: 'Quốc gia',
    'Select a country': 'Chọn quốc gia',
    'Select categories': 'Chọn ngành nghề',
    'Select a category': 'Chọn ngành nghề',
    'Province/City': 'Tỉnh/Thành phố',
    District: 'Quận/Huyện',
    Address: 'Địa chỉ',
    Skills: 'Kỹ năng',
    'Suggested Skills For You': 'Kỹ năng được đề xuất',
    'Working preference': 'Công việc mong muốn',
    'Expected location': 'Nơi làm việc',
    'Expected job function': 'Ngành nghề',
    'Expected industry': 'Lĩnh vực',
    'Expected job level': 'Cấp bậc mong muốn',
    'Expected salary': 'Mức lương mong muốn',
    'Expected top 5 benefits': 'Top 5 phúc lợi tôi mong muốn nhất',
    'This is required field': 'Thông tin bắt buộc',
    'Suggested skills for you': 'Kỹ năng được đề xuất',
    'Highest education': 'Bằng cấp cao nhất',
    'Years of experience': 'Số năm kinh nghiệm',
    Welcome: 'Xin chào',
    "You're all set to embark on a journey with Vietnamworks! Let's begin by getting to know the platform.": 'Bạn đã sẵn sàng khám phá Vietnamworks! Hãy bắt đầu bằng việc khám phá về nền tảng này.',
    "Let's go": 'Khám phá ngay',
    'Do you have a CV yet?': 'Bạn đã có hồ sơ ứng tuyển chưa?',
    "We're using this info to make your experience unique.": 'Chúng tôi sử dụng thông tin này để làm trải nghiệm của bạn trở nên độc đáo hơn.',
    'Allocating 5 - 8 minutes for your information can pave the way to your dream job or the right company for you.': 'Dành 5 - 8 phút để chia sẻ thông tin có thể mở ra cơ hội tìm được công việc mơ ước hoặc công ty phù hợp nhất với bạn.',
    "No profile yet? Let's build your VietnamWorks profile together.": 'Chưa có hồ sơ? Hãy cùng tạo hồ sơ VietnamWorks của bạn.',
    'Allocating 15 - 20 minutes to provide your details, ensuring you have a professional CV and easy profile management down the road.': 'Dành 15 - 20 phút để chia sẻ thông tin để đảm bảo bạn có một hồ sơ chuyên nghiệp và quản lý hồ sơ dễ dàng trong tương lai.',
    Back: 'Trở lại',
    Continue: 'Tiếp tục',
    'Upload your CV now': 'Hãy tải lên hồ sơ của bạn ngay bây giờ',
    'You can make CV updates whenever you need, no worries.': 'Hãy yên tâm, bạn có thể dễ dàng thay đổi hồ sơ sau này.',
    'Share a bit about who you are': 'Hãy giới thiệu một chút về bản thân bạn',
    "This information plays a key role in introducing you to employers, and it's editable at any time.": 'Thông tin này đóng vai trò quan trọng trong việc giới thiệu bạn đến nhà tuyển dụng và bạn có thể sửa đổi nó bất cứ lúc nào.',
    // trans
    'This field is required.': 'Vui lòng nhập thông tin.',
    'This is not a valid email address.': 'Địa chỉ email không hợp lệ.',
    'Please do not enter numbers or special characters.': 'Vui lòng không nhập số hoặc kí tự đặc biệt.',
    'Please do not enter phone number or email.': 'Vui lòng không nhập số điện thoại hoặc email',
    'Please do not enter special characters.': 'Vui lòng không nhập kí tự đặc biệt.',
    'The phone number format is invalid.': 'Số điện thoại của bạn không hợp lệ.',
    "You've successfully set up your profile": 'Bạn đã thiết lập hồ sơ thành công',
    'Congratulations! Your profile is good to go. Start your journey towards your dream job and connect with potential employers.': 'Xin chúc mừng! Hồ sơ của bạn đã hoàn thiện. Bắt đầu hành trình tìm kiếm công việc mơ ước và kết nối với các nhà tuyển dụng tiềm năng.',
    'Enter your job title': 'Nhập chức danh của bạn',
    'Enter your address': 'Nhập địa chỉ của bạn',
    'Enter your current salary': 'Nhập mức lương hiện tại của bạn',
    'Enter your expected salary': 'Nhập mức lương mong muốn của bạn',
    'Enter your year experience': 'Nhập số năm kinh nghiệm của bạn',
    'Please select...': 'Vui lòng chọn...',
    'No Result Found': 'Không Có Kết Quả Nào',
    Search: 'Tìm',
    'USD/month': 'USD/tháng',
    Year: 'Năm',
    'Add location': 'Thêm nơi làm việc',
    'Required field': 'Thông tin bắt buộc',
    Bonus: 'Tiền thưởng',
    'Healthcare Plan': 'Chăm sóc sức khỏe',
    'Paid Leave': 'Nghỉ phép có lương ',
    Training: 'Đào tạo',
    Awards: 'Giải thưởng',
    Library: 'Thư viện',
    Laptop: 'Máy tính xách tay',
    Mobile: 'Điện thoại',
    Travel: 'Cơ hội du lịch',
    'Team Activities': 'Hoạt động nhóm',
    Transportation: 'Xe đưa đón',
    Canteen: 'Căn tin',
    Vouchers: 'Phiếu quà tặng',
    Kindergarten: 'Nhà trẻ',
    Others: 'Khác',
    'View my profile': 'Xem hồ sơ',
    'You have added a maximum of 3 locations': 'Bạn đã tạo tối đa 3 khu vực',
    'You have selected the max number of 3 categories': 'Bạn đã lựa chọn tối đa 3 ngành nghề',
    'my-profile': 'ho-so'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
